import React, { useContext, useState, useEffect, useCallback } from 'react';

import { SearchFormActionContext } from 'context/SearchFormContext';

import { QaIdentifier, useQa } from 'hooks/useQa';

import { CommunicationContext } from 'utility/Provide/Context/PageContext';

import { SearchParam } from 'types/Search/params';

import { ActiveFilter } from 'proto/Search/ActiveFilter';

import { useActiveFilter } from '../../Active/__hooks/useActiveFilter';
import { EVENT_REMOVE_KI_FILTER, EVENT_REMOVE_ALL_KI_FILTER } from '../config';

import Element from './Element';

const FilterChips: React.FC<{ filters: ActiveFilter[] }> = ({ filters }) => {
    const [localFilters, setLocalFilters] = useState<ActiveFilter[]>(filters);

    const { react, components } = useContext(CommunicationContext);
    const { removeActiveFilterFromSearch } = useActiveFilter();
    const { removeActiveFilter } = useContext(SearchFormActionContext);
    const qaAttr = useQa(QaIdentifier.Ai_Smart_Filter_Chips);

    useEffect(() => {
        setLocalFilters(filters);
    }, [filters]);

    const removeLocalFilter = useCallback((filterId: string) => {
        setLocalFilters((prev) =>
            prev.filter((chip) => chip.key + chip.label !== filterId)
        );
    }, []);

    const removeAllLocalFilter = useCallback(() => {
        setLocalFilters([]);
    }, []);

    useEffect(() => {
        react.bind(EVENT_REMOVE_KI_FILTER, removeLocalFilter);
        react.bind(EVENT_REMOVE_ALL_KI_FILTER, removeAllLocalFilter);

        return () => {
            react.unbind(EVENT_REMOVE_KI_FILTER, removeLocalFilter);
            react.unbind(EVENT_REMOVE_ALL_KI_FILTER, removeAllLocalFilter);
        };
    }, [react, removeLocalFilter, removeAllLocalFilter]);

    const handleFilterClick = useCallback(
        (filter: ActiveFilter) => {
            const filterId = filter.key + filter.label;
            removeLocalFilter(filterId);
            removeActiveFilter(filterId);
            removeActiveFilterFromSearch(filter.actionList);

            if (filter.actionList[0].parameter === SearchParam.GeoFence) {
                components.travel.map.mapService.disableDynamicSearch();
            }
        },
        [
            removeLocalFilter,
            removeActiveFilter,
            removeActiveFilterFromSearch,
            components.travel.map.mapService,
        ]
    );

    return (
        <div {...qaAttr}>
            {localFilters.map((filter) => (
                <Element
                    key={filter.key + filter.label}
                    activeFilter={filter}
                    onClick={() => handleFilterClick(filter)}
                />
            ))}
        </div>
    );
};

export default FilterChips;
